import { bootstrap } from "./bootstrap";

// With defer attribute DOM is ready; safety check for edge cases
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { void bootstrap(); });
} else {
    void bootstrap();
}